import { memo, useRef, useState } from 'react';
import { Button, Col, Form, InputGroup, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useClickAway } from 'react-use';
import CommonButtonWithInput from '../../partials/commonButtonWithInput';
import moment from 'moment';

const GynecologyHistory = ({
  selectedData,
  selectedHistories,
  setSelectedHistories,
}) => {
  let { gynecology } = selectedData || {};
  const [isFpBtn, setIsFpBtn] = useState(false);
  const [isGravida, setIsGravida] = useState(false);
  const [isParaNumber, setIsParaNumber] = useState(false);
  const [isParaSign, setIsParaSign] = useState(false);
  const [paraNumberField, setParaNumberField] = useState('');
  const [paraSignField, setParaSignField] = useState('');
  const ftArr = [
    'Barrier',
    'Pill',
    'Inj. DEPO',
    'IUD',
    'Implant',
    'Natural',
    'Nill',
  ];
  const gravidaArr = [
    '',
    '0',
    'Primi',
    '1st',
    '2nd',
    '3rd',
    '4th',
    '5th',
    '6th',
    '7th',
    '8th',
    '9th',
    '10th',
    '11th',
    '12th',
    '13th',
    '14th',
    '15th',
    '16th',
  ];

  const paraNumbeArr = ['', '0', 1, 2, 3, 4, 5, 6, 7, 8, 9];

  const paraPlusMinusArr = ['', '+', '-'];

  let selectedGynecology = gynecology || {
    mc: {
      regular: false,
      irregular: false,
      menopause: false,
      surgicalMenopause: false,
      note: '',
    },
    //mcNote: '',
    mp: '',
    mcVal: '',
    lmp: '',
    lmpNote: '',
    edd: '',
    eddNote: '',
    showEdd: false,
    maritalStatus: {
      married: false,
      unmarried: false,
    },
    marriedFor: {
      years: '',
      months: '',
      days: '',
      hours: '',
    },
    familyPlanning: {
      husbandAbroad: false,
      separated: false,
    },
    bilateralTubalLigation: '',
    gravida: '',
    gravidaNote: '',
    paraFirst: '',
    paraFirstSign: '',
    paraSecond: '',
    paraSecondSign: '',
    paraThird: '',
    paraThirdSign: '',
    paraFourth: '',
    paraFourthSign: '',
    paraFifth: '',
    paraFifthSign: '',
    paraNote: '',
    ageOfLastChild: {
      years: '',
      months: '',
      days: '',
      hours: '',
      note: '',
    },
  };

  const calculateEDDFromLMP = (lmpDate) => {
    return moment(lmpDate).add(40, 'weeks').format('YYYY-MM-DD');
  };

  const handleData = (rowName, fieldName, val, anotherVal, isTyping) => {
    const updatedData = { ...selectedGynecology };

    console.log(rowName, fieldName, val, anotherVal, 'testttt1');

    switch (rowName) {
      case 'edd':
        updatedData[fieldName] = val;
        break;
      case 'lmp':
        updatedData[fieldName] = val;
        updatedData['edd'] = calculateEDDFromLMP(val);
        break;
      case 'mc':
        if (fieldName !== 'note') {
          updatedData[rowName] = {
            regular: false,
            irregular: false,
            menopause: false,
          };
        }
        updatedData[rowName][fieldName] = val;
        break;
      case 'maritalStatus':
        updatedData[rowName] = {
          married: false,
          unmarried: false,
        };
        updatedData[rowName][fieldName] = val;
        break;
      case 'bilateralTubalLigation':
        updatedData[rowName] = val;
        break;
      case 'familyPlanning':
        updatedData[rowName] = {
          husbandAbroad: false,
          separated: false,
        };
        updatedData[rowName][fieldName] = val;
        break;
      case 'marriedFor':
      case 'ageOfLastChild':
        updatedData[rowName][fieldName] = val;
        break;
      case 'paraFirst':
      case 'paraFirstSign':
      case 'paraSecond':
      case 'paraSecondSign':
      case 'paraThird':
      case 'paraThirdSign':
      case 'paraFourth':
      case 'paraFourthSign':
      case 'paraFifth':
      //case 'paraFifthSign':
        if (!isTyping) {
          setIsParaNumber(false);
          setIsParaSign(false);
        }
        updatedData[rowName] = anotherVal;
        break;
      case 'fp':
      case 'gravida':
        updatedData[fieldName] = anotherVal;
        if (!isTyping) {
          setIsFpBtn(false);
          setIsGravida(false);
        }
        break;
      default:
        // if (fieldName === 'fp' || fieldName === 'gravida') {
        //   val = anotherVal;
        //   fieldName === 'fp' ? setIsFpBtn(false) : setIsGravida(false);
        // }
        updatedData[fieldName] = val;
    }
    //selectedData['gynecology'] = updatedData;
    setSelectedHistories({ ...selectedHistories, gynecology: updatedData });
  };

  const clearData = (itemName) => {
    switch (itemName) {
      case 'mc':
        selectedGynecology[itemName] = {
          regular: false,
          irregular: false,
          menopause: false,
          note: null,
        };
        break;
      case 'maritalStatus':
        selectedGynecology[itemName] = {
          married: false,
          unmarried: false,
        };
        break;
      case 'bilateralTubalLigation':
        selectedGynecology[itemName] = '';
        break;
      case 'familyPlanning':
        selectedGynecology[itemName] = {
          husbandAbroad: false,
          separated: false,
        };
        break;
      default:
    }
    selectedData['gynecology'] = selectedGynecology;
    setSelectedHistories({ ...selectedData });
  };

  const refG = useRef(null);
  useClickAway(refG, (e) => {
    setIsGravida(false);
  });

  const refFp = useRef(null);
  useClickAway(refFp, (e) => {
    setIsFpBtn(false);
  });

  const refPara = useRef(null);
  useClickAway(refPara, (e) => {
    setIsParaNumber(false);
    setIsParaSign(false);
  });

  return (
    <div className="gynocology-history">
      <div className="title-gyne-examination">Menstrual History:</div>
      <hr className="hr" />
      <Row className="mb-2" style={{ alignItems: 'center' }}>
        <Col md={1}>MC:</Col>
        <Col>
          <Row>
            <Col>
              <Form.Check
                type={`radio`}
                id={`regular`}
                label={`Regular`}
                checked={selectedGynecology?.mc?.regular == true}
                onChange={(e) => handleData('mc', 'regular', e.target.checked)}
              />
            </Col>
            <Col md={7}>
              <Form.Check
                type={`radio`}
                id={`irregular`}
                label={`Irregular`}
                checked={selectedGynecology?.mc?.irregular === true}
                onChange={(e) =>
                  handleData('mc', 'irregular', e.target.checked)
                }
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col>
              <Form.Check
                type={`radio`}
                id={`menopause`}
                label={`Menopause`}
                checked={selectedGynecology?.mc?.menopause === true}
                onChange={(e) =>
                  handleData('mc', 'menopause', e.target.checked)
                }
              />
            </Col>
            <Col md={7}>
              <Form.Check
                type={`radio`}
                id={`SurgicalMenopause`}
                label={`Surgical Menopause`}
                checked={selectedGynecology?.mc?.surgicalMenopause === true}
                onChange={(e) =>
                  handleData('mc', 'surgicalMenopause', e.target.checked)
                }
              />
            </Col>
          </Row>
        </Col>
        <Col>
          <Row style={{ alignItems: 'center' }}>
            <Col md={2} className="pr-0 pl-0">
              <Button
                size="sm"
                variant="outline-danger"
                className="clr-btn"
                onClick={() => clearData('mc')}
              >
                Clear
              </Button>
            </Col>
            <Col>
              <Form.Control
                size="sm"
                as="textarea"
                rows={2}
                placeholder="Add Note"
                defaultValue={selectedGynecology?.mc?.note}
                onChange={(e) => handleData('mc', 'note', e.target.value)}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="mb-2">
        <Col md={6}>
          <Row>
            <Col md={1} className="mp-mc">
              <div>MP</div>
              <div>MC</div>
            </Col>
            <Col md={1} className="mp-mc-right">
              :
            </Col>
            <Col md={6} className="pr-0">
              <Form.Control
                size="sm"
                type="text"
                placeholder="Add MP"
                defaultValue={selectedGynecology?.mp}
                onChange={(e) => handleData('', 'mp', e.target.value)}
              />
              <div className="border-mp-mc"></div>
              <Form.Control
                size="sm"
                type="text"
                placeholder="Add MC"
                defaultValue={selectedGynecology?.mcVal}
                onChange={(e) => handleData('', 'mcVal', e.target.value)}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="mb-2">
        <Col md={1}>LMP: </Col>
        <Col md={3} className="pr-0">
          <DatePicker
            showIcon
            selected={
              selectedGynecology?.lmp ? new Date(selectedGynecology?.lmp) : null
            }
            onChange={(date) => handleData('lmp', 'lmp', date)}
            dateFormat="dd/MM/yyyy"
            className="form-control form-control-sm"
            placeholderText="dd/mm/yyyy"
            popperPlacement="bottom-start"
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1em"
                height="1em"
                viewBox="0 0 48 48"
              >
                <mask id="ipSApplication0">
                  <g
                    fill="none"
                    stroke="#fff"
                    strokeLinejoin="round"
                    strokeWidth="4"
                  >
                    <path strokeLinecap="round" d="M40.04 22v20h-32V22"></path>
                    <path
                      fill="#fff"
                      d="M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z"
                    ></path>
                  </g>
                </mask>
                <path
                  fill="currentColor"
                  d="M0 0h48v48H0z"
                  mask="url(#ipSApplication0)"
                ></path>
              </svg>
            }
          />
        </Col>
        <Col md={3}></Col>
        <Col>
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            placeholder="Add LMP Note"
            defaultValue={selectedGynecology?.lmpNote}
            onChange={(e) => handleData('', 'lmpNote', e.target.value)}
          />
        </Col>
      </Row>
      <Row>
        <Col md={1}>EDD: </Col>
        <Col md={3} className="pr-0">
          <DatePicker
            showIcon
            selected={
              selectedGynecology?.edd ? new Date(selectedGynecology?.edd) : null
            }
            onChange={(date) => handleData('edd', 'edd', date)}
            dateFormat="dd/MM/yyyy"
            className="form-control form-control-sm"
            placeholderText="dd/mm/yyyy"
            popperPlacement="bottom-start"
            shouldCloseOnScroll={false}
            popperOptions={{
              middleware: [],
              placement: 'bottom-start',
            }}
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1em"
                height="1em"
                viewBox="0 0 48 48"
              >
                <mask id="ipSApplication0">
                  <g
                    fill="none"
                    stroke="#fff"
                    strokeLinejoin="round"
                    strokeWidth="4"
                  >
                    <path strokeLinecap="round" d="M40.04 22v20h-32V22"></path>
                    <path
                      fill="#fff"
                      d="M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z"
                    ></path>
                  </g>
                </mask>
                <path
                  fill="currentColor"
                  d="M0 0h48v48H0z"
                  mask="url(#ipSApplication0)"
                ></path>
              </svg>
            }
          />
        </Col>
        <Col md={3} className="d-flex align-items-center">
          <Form.Check
            type={`checkbox`}
            id={`eddCheckbox`}
            label={`show in Prescription`}
            style={{ whiteSpace: 'nowrap' }}
            checked={selectedGynecology?.showEdd === true}
            onChange={(e) => handleData('', 'showEdd', e.target.checked)}
          />
        </Col>
        <Col>
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            placeholder="Add EDD Note"
            defaultValue={selectedGynecology?.eddNote}
            onChange={(e) => handleData('', 'eddNote', e.target.value)}
          />
        </Col>
      </Row>
      <div className="title-gyne-examination">Obstetrical History:</div>
      <hr className="hr" />
      <Row className="mb-1">
        <Col md={3}>Marital Status:</Col>
        <Col md={6}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Form.Check
              type={`radio`}
              id={`married`}
              label={`Married`}
              checked={selectedGynecology?.maritalStatus?.married === true}
              onChange={(e) =>
                handleData('maritalStatus', 'married', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`unmarried`}
              label={`Unmarried`}
              checked={selectedGynecology?.maritalStatus?.unmarried === true}
              onChange={(e) =>
                handleData('maritalStatus', 'unmarried', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`divorce`}
              label={`Divorce`}
              checked={selectedGynecology?.maritalStatus?.divorce === true}
              onChange={(e) =>
                handleData('maritalStatus', 'divorce', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`widow`}
              label={`Widow`}
              checked={selectedGynecology?.maritalStatus?.widow === true}
              onChange={(e) =>
                handleData('maritalStatus', 'widow', e.target.checked)
              }
            />
          </div>
        </Col>
        {/* <Col md={2}>
          <Form.Check
            type={`radio`}
            id={`unmarried`}
            label={`Unmarried`}
            checked={selectedGynecology?.maritalStatus?.unmarried === true}
            onChange={(e) =>
              handleData('maritalStatus', 'unmarried', e.target.checked)
            }
          />
        </Col>
        <Col md={2}>
          <Form.Check
            type={`radio`}
            id={`divorce`}
            label={`divorce`}
            checked={selectedGynecology?.maritalStatus?.divorce === true}
            onChange={(e) =>
              handleData('maritalStatus', 'divorce', e.target.checked)
            }
          />
        </Col>
        <Col md={2}>
          <Form.Check
            type={`radio`}
            id={`widow`}
            label={`widow`}
            checked={selectedGynecology?.maritalStatus?.widow === true}
            onChange={(e) =>
              handleData('maritalStatus', 'widow', e.target.checked)
            }
          />
        </Col> */}
        <Col md={1}>
          <Button
            size="sm"
            variant="outline-danger"
            className="clr-btn"
            onClick={() => clearData('maritalStatus')}
          >
            Clear
          </Button>
        </Col>
      </Row>
      <Row>
        <Col md={3}>Married For:</Col>
        <Col md={4} sm={4}>
          <InputGroup className="mb-3">
            <Form.Control
              size="sm"
              placeholder="Years"
              aria-label="Years"
              defaultValue={selectedGynecology?.marriedFor?.years}
              onChange={(e) =>
                handleData('marriedFor', 'years', e.target.value)
              }
            />
            <Form.Control
              size="sm"
              placeholder="Months"
              aria-label="Months"
              defaultValue={selectedGynecology?.marriedFor?.months}
              onChange={(e) =>
                handleData('marriedFor', 'months', e.target.value)
              }
            />
            <Form.Control
              size="sm"
              placeholder="Days"
              aria-label="Days"
              defaultValue={selectedGynecology?.marriedFor?.days}
              onChange={(e) => handleData('marriedFor', 'days', e.target.value)}
            />
            <Form.Control
              size="sm"
              placeholder="Hours"
              aria-label="Hours"
              defaultValue={selectedGynecology?.marriedFor?.hours}
              onChange={(e) =>
                handleData('marriedFor', 'hours', e.target.value)
              }
            />
          </InputGroup>
        </Col>
      </Row>
      <Row className="mb-1">
        <Col md={3}>Family Planning:</Col>
        <Col md={3}>
          <Form.Check
            type={`radio`}
            id={`husbandAbroadf`}
            label={`Husband Abroad`}
            checked={selectedGynecology?.familyPlanning?.husbandAbroad === true}
            onChange={(e) =>
              handleData('familyPlanning', 'husbandAbroad', e.target.checked)
            }
          />
        </Col>
        <Col md={2}>
          <Form.Check
            type={`radio`}
            id={`separatedf`}
            label={`Separated`}
            checked={selectedGynecology?.familyPlanning?.separated === true}
            onChange={(e) =>
              handleData('familyPlanning', 'separated', e.target.checked)
            }
          />
        </Col>
        <Col md={1}>
          <Button
            size="sm"
            variant="outline-danger"
            className="clr-btn"
            onClick={() => clearData('familyPlanning')}
          >
            Clear
          </Button>
        </Col>
      </Row>
      <Row className="mb-1">
        <Col md={3}>Bilateral Tubal Ligation:</Col>
        <Col md={3}>
          <Form.Check
            type={`radio`}
            id={`bilateralTubalLigation-true`}
            label={`Yes`}
            checked={selectedGynecology?.bilateralTubalLigation === 'Yes'}
            onChange={(e) => handleData('bilateralTubalLigation', '', 'Yes')}
          />
        </Col>
        <Col md={2}>
          <Form.Check
            type={`radio`}
            id={`bilateralTubalLigation-false`}
            label={`No`}
            checked={selectedGynecology?.bilateralTubalLigation === 'No'}
            onChange={(e) => handleData('bilateralTubalLigation', '', 'No')}
          />
        </Col>
        <Col md={1}>
          <Button
            size="sm"
            variant="outline-danger"
            className="clr-btn"
            onClick={() => clearData('bilateralTubalLigation')}
          >
            Clear
          </Button>
        </Col>
      </Row>
      <Row className="mb-3 mt-3">
        <Col md={3}>Gravida:</Col>
        <Col md={4} sm={2} className="pr-0 gravida-area" ref={refG}>
          {/* <Form.Control
            size="sm"
            type="text"
            placeholder="Gravida"
            readOnly
            style={{ backgroundColor: '#FFFFFF' }}
            value={selectedGynecology?.gravida}
            onClick={() => setIsGravida(isGravida ? false : true)}
          /> */}
          <Button
            size="sm"
            className={`common-group-btn ${
              selectedGynecology?.gravida ? 'assigned-value' : ''
            }`}
            variant="outline-secondary"
            onClick={() => setIsGravida(isGravida ? false : true)}
          >
            {selectedGynecology?.gravida ? (
              <span>{selectedGynecology?.gravida}</span>
            ) : (
              <i
                className="fa fa-sort"
                style={{ fontSize: '17px' }}
                aria-hidden="true"
              ></i>
            )}
          </Button>
          {isGravida && (
            <CommonButtonWithInput
              unitArray={gravidaArr}
              clickAction={handleData}
              rowName="gravida"
              colName="gravida"
              indexName="common-group-btn"
            />
          )}
        </Col>
        <Col md={5}>
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            placeholder="Add Note"
            defaultValue={selectedGynecology?.gravidaNote}
            onChange={(e) => handleData('', 'gravidaNote', e.target.value)}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={3}>Para:</Col>
        <Col ref={refPara} className="pr-0">
          <Button
            size="sm"
            className={`common-group-btn ${
              selectedGynecology?.paraFirst ? 'assigned-value' : ''
            }`}
            variant="outline-secondary"
            onClick={() => {
              setIsParaSign(false);
              setIsParaNumber(true);
              setParaNumberField('paraFirst');
            }}
          >
            {selectedGynecology?.paraFirst ? (
              <span>{selectedGynecology?.paraFirst}</span>
            ) : (
              <i
                className="fa fa-sort"
                style={{ fontSize: '15px' }}
                aria-hidden="true"
              ></i>
            )}
          </Button>
          <Button
            size="sm"
            className={`common-group-btn ${
              selectedGynecology?.paraFirstSign ? 'assigned-value' : ''
            }`}
            variant="outline-secondary"
            onClick={() => {
              setIsParaNumber(false);
              setIsParaSign(true);
              setParaSignField('paraFirstSign');
            }}
          >
            {selectedGynecology?.paraFirstSign ? (
              <span>{selectedGynecology?.paraFirstSign}</span>
            ) : (
              <i
                className="fa fa-sort"
                style={{ fontSize: '15px' }}
                aria-hidden="true"
              ></i>
            )}
          </Button>
          <Button
            size="sm"
            className={`common-group-btn ${
              selectedGynecology?.paraSecond ? 'assigned-value' : ''
            }`}
            variant="outline-secondary"
            onClick={() => {
              setIsParaSign(false);
              setIsParaNumber(true);
              setParaNumberField('paraSecond');
            }}
          >
            {selectedGynecology?.paraSecond ? (
              <span>{selectedGynecology?.paraSecond}</span>
            ) : (
              <i
                className="fa fa-sort"
                style={{ fontSize: '15px' }}
                aria-hidden="true"
              ></i>
            )}
          </Button>
          <Button
            size="sm"
            style={{padding: '0.2rem 0.41rem'}}
            className={`common-group-btn ${
              selectedGynecology?.paraSecondSign ? 'assigned-value' : ''
            }`}
            variant="outline-secondary"
            onClick={() => {
              setIsParaNumber(false);
              setIsParaSign(true);
              setParaSignField('paraSecondSign');
            }}
          >
            {selectedGynecology?.paraSecondSign ? (
              <span>{selectedGynecology?.paraSecondSign}</span>
            ) : (
              <i
                className="fa fa-sort"
                style={{ fontSize: '15px' }}
                aria-hidden="true"
              ></i>
            )}
          </Button>
          <Button
            size="sm"
            style={{padding: '0.2rem 0.41rem'}}
            className={`common-group-btn ${
              selectedGynecology?.paraThird ? 'assigned-value' : ''
            }`}
            variant="outline-secondary"
            onClick={() => {
              setIsParaSign(false);
              setIsParaNumber(true);
              setParaNumberField('paraThird');
            }}
          >
            {selectedGynecology?.paraThird ? (
              <span>{selectedGynecology?.paraThird}</span>
            ) : (
              <i
                className="fa fa-sort"
                style={{ fontSize: '15px' }}
                aria-hidden="true"
              ></i>
            )}
          </Button>
          <Button
            size="sm"
            style={{padding: '0.2rem 0.41rem'}}
            className={`common-group-btn ${
              selectedGynecology?.paraThirdSign ? 'assigned-value' : ''
            }`}
            variant="outline-secondary"
            onClick={() => {
              setIsParaNumber(false);
              setIsParaSign(true);
              setParaSignField('paraThirdSign');
            }}
          >
            {selectedGynecology?.paraThirdSign ? (
              <span>{selectedGynecology?.paraThirdSign}</span>
            ) : (
              <i
                className="fa fa-sort"
                style={{ fontSize: '15px' }}
                aria-hidden="true"
              ></i>
            )}
          </Button>
          <Button
            size="sm"
            style={{padding: '0.2rem 0.41rem'}}
            className={`common-group-btn ${
              selectedGynecology?.paraFourth ? 'assigned-value' : ''
            }`}
            variant="outline-secondary"
            onClick={() => {
              setIsParaSign(false);
              setIsParaNumber(true);
              setParaNumberField('paraFourth');
            }}
          >
            {selectedGynecology?.paraFourth ? (
              <span>{selectedGynecology?.paraFourth}</span>
            ) : (
              <i
                className="fa fa-sort"
                style={{ fontSize: '15px' }}
                aria-hidden="true"
              ></i>
            )}
          </Button>
          <Button
            size="sm"
            style={{padding: '0.2rem 0.41rem'}}
            className={`common-group-btn ${
              selectedGynecology?.paraFourthSign ? 'assigned-value' : ''
            }`}
            variant="outline-secondary"
            onClick={() => {
              setIsParaNumber(false);
              setIsParaSign(true);
              setParaSignField('paraFourthSign');
            }}
          >
            {selectedGynecology?.paraFourthSign ? (
              <span>{selectedGynecology?.paraFourthSign}</span>
            ) : (
              <i
                className="fa fa-sort"
                style={{ fontSize: '15px' }}
                aria-hidden="true"
              ></i>
            )}
          </Button>
          <Button
            size="sm"
            style={{padding: '0.2rem 0.41rem'}}
            className={`common-group-btn ${
              selectedGynecology?.paraFifth ? 'assigned-value' : ''
            }`}
            variant="outline-secondary"
            onClick={() => {
              setIsParaSign(false);
              setIsParaNumber(true);
              setParaNumberField('paraFifth');
            }}
          >
            {selectedGynecology?.paraFifth ? (
              <span>{selectedGynecology?.paraFifth}</span>
            ) : (
              <i
                className="fa fa-sort"
                style={{ fontSize: '15px' }}
                aria-hidden="true"
              ></i>
            )}
          </Button>
          {isParaNumber && (
            <CommonButtonWithInput
              unitArray={paraNumbeArr}
              clickAction={handleData}
              rowName={paraNumberField}
              colName=""
              indexName="common-group-btn"
              value={selectedGynecology[paraNumberField] || ''}
              isPara={true}
            />
          )}
          {isParaSign && (
            <CommonButtonWithInput
              unitArray={paraPlusMinusArr}
              clickAction={handleData}
              rowName={paraSignField}
              colName=""
              indexName="common-group-btn"
            />
          )}
        </Col>
        <Col md={5}>
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            placeholder="Add Note"
            defaultValue={selectedGynecology?.paraNote}
            onChange={(e) => handleData('', 'paraNote', e.target.value)}
          />
        </Col>
      </Row>
      <Row>
        <Col md={3}>Age of last child:</Col>
        <Col md={4}>
          <InputGroup className="mb-3">
            <Form.Control
              size="sm"
              placeholder="Years"
              defaultValue={selectedGynecology?.ageOfLastChild?.years}
              onChange={(e) =>
                handleData('ageOfLastChild', 'years', e.target.value)
              }
            />
            <Form.Control
              size="sm"
              placeholder="Months"
              defaultValue={selectedGynecology?.ageOfLastChild?.months}
              onChange={(e) =>
                handleData('ageOfLastChild', 'months', e.target.value)
              }
            />
            <Form.Control
              size="sm"
              placeholder="Days"
              defaultValue={selectedGynecology?.ageOfLastChild?.days}
              onChange={(e) =>
                handleData('ageOfLastChild', 'days', e.target.value)
              }
            />
            <Form.Control
              size="sm"
              placeholder="Hours"
              defaultValue={selectedGynecology?.ageOfLastChild?.hours}
              onChange={(e) =>
                handleData('ageOfLastChild', 'hours', e.target.value)
              }
            />
          </InputGroup>
        </Col>
        <Col md={5}>
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            placeholder="Add Note"
            defaultValue={selectedGynecology?.ageOfLastChild?.note}
            onChange={(e) =>
              handleData('ageOfLastChild', 'note', e.target.value)
            }
          />
        </Col>
      </Row>
      <div className="title-gyne-examination">Contraceptive Method:</div>
      <hr className="hr" />
      <Row className="mb-5">
        <Col md={3}>FP:</Col>
        <Col md={2} sm={2} ref={refFp}>
          {/* <Form.Control
            size="sm"
            type="text"
            placeholder="Select FP"
            readOnly
            style={{ backgroundColor: '#FFFFFF' }}
            value={selectedGynecology?.fp}
            onClick={() => setIsFpBtn(isFpBtn ? false : true)}
          /> */}
          <Button
            size="sm"
            className={`common-group-btn ${
              selectedGynecology?.fp ? 'assigned-value' : ''
            }`}
            variant="outline-secondary"
            onClick={() => setIsFpBtn(isFpBtn ? false : true)}
          >
            {selectedGynecology?.fp ? (
              <span>{selectedGynecology?.fp}</span>
            ) : (
              <i
                className="fa fa-sort"
                style={{ fontSize: '17px' }}
                aria-hidden="true"
              ></i>
            )}
          </Button>
          {isFpBtn && (
            <CommonButtonWithInput
              unitArray={ftArr}
              clickAction={handleData}
              rowName="fp"
              colName="fp"
              indexName="common-group-btn"
            />
          )}
        </Col>
        <Col md={2}></Col>
        <Col>
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            placeholder="Add Note"
            defaultValue={selectedGynecology?.fpNote}
            onChange={(e) => handleData('', 'fpNote', e.target.value)}
          />
        </Col>
      </Row>
    </div>
  );
};

export default memo(GynecologyHistory);
